<script lang="ts" setup>
import FilterTable from "@/components/Common/Table/FilterTable.vue";
import { ref } from "vue";
import type { Header } from "vue3-easy-data-table";
import EasyDataTable from "vue3-easy-data-table";
import "vue3-easy-data-table/dist/style.css";
import Swal from "sweetalert2";
import router from "@/router";
import BaseLoading from "@/components/Common/BaseLoading.vue";
import { useDepartmentStore } from "@/stores/master/department";
import { toast } from "vue-sonner";
import { hasAccess } from "@/utils/helper";

const linkAdd = {
  text: "Add Department",
  url: "/master/department/create",
};

const headers: Header[] = [
  { text: "CODE", value: "code" },
  { text: "DEPARTMENT", value: "name" },
  // { text: "PARENT DEPARTMENT", value: "name" },
  { text: "DESCRIPTION", value: "description" },
  { text: "ACTIONS", value: "action" },
];

const page = ref<number>(1);
const limit = ref<number>(10);
const totalItems = ref<number>(0);
const listDepartment = ref<any>([]);
const isLoading = ref(false);
const storeDepartment = useDepartmentStore();

const loadDataDepartment = async (query = "") => {
  isLoading.value = true;
  const { success, message } = await storeDepartment.dispatchGetDepartments(
    page.value,
    limit.value,
    query
  );
  if (success) {
    listDepartment.value = await storeDepartment.departments.items;
    page.value = await storeDepartment.departments.page;
    limit.value = await storeDepartment.departments.pageSize;
    totalItems.value = await storeDepartment.departments.total;
    isLoading.value = false;
  }
};

const handleServerOptionsUpdate = (options: {
  page: number;
  rowsPerPage: number;
}) => {
  page.value = options.page;
  limit.value = options.rowsPerPage;
  loadDataDepartment();
};

const handleEdit = (department: any) => {
  router.push("/master/department/" + department);
};

const handleDelete = async (department: any) => {
  const swalWithBootstrapButtons = Swal.mixin({
    customClass: {
      cancelButton: "btn btn-danger",
      confirmButton: "btn btn-success",
    },
    buttonsStyling: false,
  });
  swalWithBootstrapButtons
    .fire({
      title: `Are you sure want to delete data ${department.name} ?`,
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
      reverseButtons: true,
    })
    .then(async (result) => {
      if (result.isConfirmed) {
        const { success, message } = await storeDepartment.dispatchDelete(
          department.id
        );
        if (success) {
          swalWithBootstrapButtons.fire({
            title: "Deleted!",
            text: "Your file has been deleted.",
            icon: "success",
          });
          loadDataDepartment();
        } else {
          toast.error(message);
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        swalWithBootstrapButtons.fire({
          title: "Cancelled",
          text: "Your action has been aborted",
          icon: "error",
        });
      }
    });
};
loadDataDepartment();
</script>
<template>
  <div class="card bg-white border-0 rounded-3 mb-4">
    <div class="card-body p-4">
      <div
        class="d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3 mb-lg-4"
      >
        <h3 class="mb-0">List Data Department</h3>
      </div>
      <FilterTable :link="linkAdd" @searchByQuery="loadDataDepartment" />
      <div class="table-content">
        <BaseLoading v-if="isLoading" />
        <EasyDataTable
          :headers="headers"
          :items="listDepartment"
          v-if="!isLoading"
          show-index
          :server-options="{
            page: page,
            rowsPerPage: limit,
          }"
          :server-items-length="totalItems"
          @update:server-options="handleServerOptionsUpdate"
          buttons-pagination
        >
          <template #item-action="props">
            <div class="d-flex gap-2">
              <button
                v-if="hasAccess('department-update')"
                class="btn btn-info btn-sm text-white"
                @click="handleEdit(props.id)"
              >
                Edit
              </button>
              <button
                v-if="hasAccess('department-update')"
                class="btn btn-danger btn-sm"
                @click="handleDelete(props)"
              >
                Delete
              </button>
            </div>
          </template>
        </EasyDataTable>
      </div>
    </div>
  </div>
</template>
